import { Routes } from '@angular/router';
import { ApplicationStartGuard } from './core/guard/application.start.guard';
import { authGuard, notAuthedGuard } from './core/guard/auth.guard';
import { TranslationLoadGuard } from './core/guard/translation.loader.guard';
import portalRoutes from './modules/eaglebe-portal/portal.routes';
import backofficeRoutes from './shared/routes/routes.backoffice';
import frontofficeRoutes from './shared/routes/routes.frontoffice';
import { environment } from 'src/environments/environment';


export default [
  {
    path: 'auth',
    loadChildren: () => import('./modules/eaglebe-auth/auth.routes'),
    canActivate: [notAuthedGuard]
  },
  {
    path: 'redirect',
    loadChildren: () => import('./modules/eaglebe-redirect/redirect.routes'),
  },
  {
    path: '',
    canActivate: [TranslationLoadGuard, ApplicationStartGuard],
    data: {
      externalLogin: environment.auth.login,
    },
    children: [
      ...frontofficeRoutes,
      ...backofficeRoutes,
      // {
      //   path: '',
      //   canActivate: [TranslationLoadGuard, ApplicationStartGuard],
      //   loadComponent: () => import('./shared/components/layout/content/content.component').then(m => m.ContentComponent),
      //   children: backofficeRoutes,
      // },
      {
        path: 'portal',
        canActivate: [authGuard],
        loadComponent: () => import('./shared/components/layout/portal/portal.component').then(m => m.PortalLayoutComponent),
        children: portalRoutes
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'portal'
      },
      {
        path: '**',
        loadComponent: () => import('./core/pages/404/p404.component').then(m => m.p404Component)
      },
    ]
  },
  {
    path: 'dashboard/management/organisation/mollie',
    loadComponent: () => import('./modules/eaglebe-backoffice/management/organisation/tabs/integrations/cards/mollie/callback/management-integrations-mollie-callback.component').then(m => m.ManagementIntegrationsMollieCallbackComponent),
    data: {
      title: "backoffice.navigation.management.management"
    },
  },
] satisfies Routes;
